module.exports = __webpack_public_path__ + "img/fish-frozen.1c327b21.png";